export default function setCssCustomProperty(propertyName: string, value: string) {
    return document.documentElement.style.setProperty(propertyName, value);
}
